// removed by extract-text-webpack-plugin
module.exports = {"stepsTextContainer":"stepsTextContainer__RpfVz"};


//////////////////
// WEBPACK FOOTER
// ./routes/program-landing-page/components/bic-steps/steps-text/style.css
// module id = 7uf7
// module chunks = 444